import templateUrl from './403Forbidden.html'

/**
 * Route 403 Forbidden.
 *
 * @namespace routes.403Forbidden
 * @type {TmrRoute}
 */
export const route = {
  name: 'error403',
  label: '403.TITLE',
  component: 'tmrForbidden',
  accessControl: [],
  accessAnonymous: true,
}

/**
 * Component for the route 403 Forbidden.
 *
 * @type {ngComponent}
 */
export const tmrForbidden = {
  ngType: 'component',
  templateUrl,
}
